import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useHalloween } from "@/lib/halloween";
import { useLeft } from "@/lib/quest";

const Countdown = ({ end }) => {
  const { text } = useLeft(end);
  return <span className="tabular-nums" data-testid="hw-card-timer">{text}</span>;
};

export function HalloweenFeedCard() {
  const on = useHalloween();
  const [d, setD] = useState(null);
  useEffect(() => { if (on) api.get("/halloween").then(({ data }) => setD(data)).catch(() => {}); }, [on]);
  if (!on) return null;
  const top = (d?.entries || []).slice(0, 3);
  return (
    <Link to="/halloween" className="hw-card block relative overflow-hidden rounded-[2rem] p-5 text-white shadow-xl" data-testid="halloween-feed-card">
      <span className="absolute -right-3 -top-4 text-7xl opacity-90 hw-float" aria-hidden>🎃</span>
      <span className="absolute right-20 top-3 text-2xl hw-float" style={{ animationDelay: "1s" }} aria-hidden>🦇</span>
      <p className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-orange-300">Halloween-Event · nur heute Nacht</p>
      <h3 className="mt-1 font-display text-2xl font-black leading-tight pr-16">Grusel-Nacht in der Community 👻</h3>
      <p className="mt-1 text-sm text-white/80">Endet um 6 Uhr · noch {d ? <Countdown end={d.end} /> : "…"}</p>
      <div className="mt-4 grid grid-cols-2 gap-2.5">
        <div className="rounded-2xl bg-white/10 ring-1 ring-white/15 p-3" data-testid="hw-card-bonus">
          <p className="text-xl">✍️</p>
          <p className="mt-1 text-sm font-extrabold leading-tight">Doppelte Punkte</p>
          <p className="text-[11px] text-white/70 leading-snug">für jeden Beitrag mit dem Wort „Halloween“</p>
        </div>
        <div className="rounded-2xl bg-white/10 ring-1 ring-white/15 p-3" data-testid="hw-card-contest">
          <p className="text-xl">🧛</p>
          <p className="mt-1 text-sm font-extrabold leading-tight">Kostüm-Wettbewerb</p>
          <p className="text-[11px] text-white/70 leading-snug">Top 3 gewinnen {d ? d.prizes.join(" / ") : "500 / 300 / 150"} Punkte</p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <span className="flex -space-x-2">{top.map((e) => <img key={e.id} src={e.image} alt="" className="w-9 h-9 rounded-full object-cover ring-2 ring-[#2a0f45]" />)}</span>
        <span className="text-xs text-white/80 flex-1">{d?.entries?.length ? `${d.entries.length} Kostüm${d.entries.length === 1 ? "" : "e"} im Rennen` : "Sei das erste Kostüm!"}</span>
        <span className="inline-flex items-center gap-1 h-10 pl-4 pr-3 rounded-full bg-gradient-to-r from-orange-400 to-orange-600 text-sm font-black shadow-lg" data-testid="hw-card-cta">Mitmachen <ChevronRight className="w-4 h-4" /></span>
      </div>
    </Link>
  );
}
